import i18n from 'i18next';

export const SECTIONS_INPUT_FIELDS_DATA = {
	submitUrl: 'section',
	fetchUrl: 'section',
	cancelButtonPath: 'sections',
	hasMetadata: false,
	defautlFieldValues: {
		name: ''
	},
	inputFields: [
		{
			name: 'name',
			label: i18n.t('sections:fields.name'),
			type: 'text',
			required: false
		}
	]
};
